<template>
    <div style="height:100%">
        <div class="circletab">           
            
            <div class="circlemain"><router-view/></div>   
        </div>
       
    </div>
    
</template>

<script> 
import circletabbar from '../public/circletabbar.vue'
export default {
        components:{circletabbar},
        data() {
            return {
              
            }
        },
        mounted(){
            this.onPath=this.$route.path;
        },
        methods:{

         


        }
    }
</script>

<style scoped>
.circletab{
    height: 100%;
}
.circlemain{
    height: 100%;
}


</style>




// WEBPACK FOOTER //
// src/components/pages/circle.vue